export const CHARACTER_LIMITS = {
    title: 50,
    description: 150,
    contactName: 20,
    animalName: 20,
    animalType: 20,
    breed: 20,
    lastSeen: 30,
    foundNear: 30,
    colorMarkings_custom: 20,
  };
  
  export const validateLength = (fieldName, value) => {
    const maxLength = CHARACTER_LIMITS[fieldName];
    if (maxLength && value.length > maxLength) {
      return value.substring(0, maxLength);
    }
    return value;
  };